module.exports = __webpack_public_path__ + "static/media/separ04.30b446b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/App/medias/separ04.jpg
// module id = 254
// module chunks = 0